export default "__VITE_ASSET__DRcir7To__"